import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LegacyResponsibleGamingDTO, RealityCheckConfigDTO } from './responsible-gaming-config.model';

@Injectable({
  providedIn: 'root',
})
export class ResponsibleGamingConfigService {
  constructor(private readonly http: HttpClient) {}

  public getRealityCheckConfig(playerId: number): Observable<RealityCheckConfigDTO> {
    return this.http.get<RealityCheckConfigDTO>(
      `/player-activity/api/backoffice/player/${playerId}/reality-check/config`
    );
  }

  public updateRealityCheckConfig(playerId: number, config: RealityCheckConfigDTO): Observable<void> {
    return this.http.put<void>(`/player-activity/api/backoffice/player/${playerId}/reality-check/config`, config);
  }

  public updateLegacyRealityCheckConfig(playerId: number, config: LegacyResponsibleGamingDTO): Observable<void> {
    return this.http.put<void>(`/player/v2/${playerId}/responsible-gaming-config`, config);
  }

  public getLegacyRealityCheckConfig(playerId: number): Observable<LegacyResponsibleGamingDTO> {
    return this.http.get<LegacyResponsibleGamingDTO>(`/player/v2/${playerId}/responsible-gaming-config`);
  }
}
